export default __webpack_public_path__ + "static/media/pl.f3033825.svg";